/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import * as React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { IntlProvider } from 'react-intl';

import { makeSelectLocale } from './selectors';
import { changeLocale } from './actions';
import { Dispatch } from 'redux';
import { ensureLocaleLoaded, DEFAULT_LOCALE } from 'i18n';
import { ensureEnTranslations } from 'translations';

export interface ILanguageProviderProps {
  locale: string;
  onChangeLocale: (languageLocale: string) => void;
  messages: { [locale: string]: { [id: string]: string } };
  children?: React.ReactNode;
}

export class LanguageProvider extends React.PureComponent<ILanguageProviderProps, { enReady: boolean }> {
  state = { enReady: false };

  componentDidMount(): void {
    const lang = window.localStorage.getItem('lang') || this.props.locale;
    this.props.onChangeLocale(lang);
    this.ensureLang(lang);
  }

  componentDidUpdate(): void {
    const lang = window.localStorage.getItem('lang') || this.props.locale;
    this.ensureLang(lang);
  }

  // i18n code-split: en tải dynamic. Nếu lang=en mà en chưa load → load rồi re-render.
  private ensureLang(lang: string): void {
    if (lang === 'en' && !this.hasMessages('en') && !this.state.enReady) {
      // Load CẢ IntlProvider en (FormattedMessage) LẪN helper translations() en.
      Promise.all([ensureLocaleLoaded('en'), ensureEnTranslations()]).then(() => this.setState({ enReady: true }));
    }
  }

  private hasMessages(lang: string): boolean {
    const m = this.props.messages[lang];
    return !!m && Object.keys(m).length > 0;
  }

  public render() {
    const lang = window.localStorage.getItem('lang') || this.props.locale;
    const activeLang = this.hasMessages(lang) ? lang : DEFAULT_LOCALE;
    return (
      <IntlProvider
        defaultLocale="vi"
        locale={activeLang}
        key={activeLang}
        messages={this.props.messages[activeLang as string]}
      >
        {React.Children.only(this.props.children)}
      </IntlProvider>
    );
  }
}

const mapStateToProps = createSelector(makeSelectLocale(), (locale) => ({
  locale: locale,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onChangeLocale: (languageLocale: string) => dispatch(changeLocale(languageLocale)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LanguageProvider);
